export const Types = {
  RESET_DATA_STOCK_ITEM: "stockItem/RESET_DATA",

  CHANGE_STOCK_PAGINATION: "stockItem/CHANGE_PAGINATION",

  GET_STOCK_ITEM_INDEX: "stockItem/GET_INDEX",
  GET_STOCK_ITEM_INDEX_SUCCESS: "stockItem/GET_INDEX_SUCCESS",
  GET_STOCK_ITEM_INDEX_ERROR: "stockItem/GET_INDEX_ERROR",

  GET_STOCK_ITEM_SHOW: "stockItem/GET_SHOW",
  GET_STOCK_ITEM_SHOW_SUCCESS: "stockItem/GET_SHOW_SUCCESS",
  GET_STOCK_ITEM_SHOW_ERROR: "stockItem/GET_SHOW_ERROR",

  SAVE_STOCK_ITEM: "stockItem/SAVE",
  SAVE_STOCK_ITEM_SUCCESS: "stockItem/SAVE_SUCCESS",
  SAVE_STOCK_ITEM_ERROR: "stockItem/SAVE_ERROR",

  DELETE_STOCK_ITEM: "stockItem/DELETE",
  DELETE_STOCK_ITEM_SUCCESS: "stockItem/DELETE_SUCCESS",
  DELETE_STOCK_ITEM_ERROR: "stockItem/DELETE_ERROR",

  TOGGLE_STATUS_STOCK_ITEM: "stockItem/TOGGLE_STATUS",
  TOGGLE_STATUS_STOCK_ITEM_SUCCESS: "stockItem/TOGGLE_STATUS_SUCCESS",
  TOGGLE_STATUS_STOCK_ITEM_ERROR: "stockItem/TOGGLE_STATUS_ERROR",

  SHOW_DRAWER_STOCK_ITEM: "stockItem/SHOW_DRAWER",
  HIDE_DRAWER_STOCK_ITEM: "stockItem/HIDE_DRAWER",

  SHOW_MODAL_NEW_STOCK_ITEM: "stockItem/SHOW_MODAL_NEW",
  HIDE_MODAL_NEW_STOCK_ITEM: "stockItem/HIDE_MODAL_NEW",

  GET_STOCK_ITEM_DROPDOWN: "stockItem/GET_DROPDOWN",
  GET_STOCK_ITEM_DROPDOWN_SUCCESS: "stockItem/GET_DROPDOWN_SUCCESS",
  GET_STOCK_ITEM_DROPDOWN_ERROR: "stockItem/GET_DROPDOWN_ERROR",

  REFRESH_LIST_DROPDOWN_STOCK_ITEM: "stockItem/REFRESH_LIST_DROPDOWN",
};

export const Creators = {
  changeStockPagination: (page, size) => ({
    type: Types.CHANGE_STOCK_PAGINATION,
    payload: { page, size },
  }),
  indexStockItem: (
    groupId,
    farmId,
    page = 0,
    size = 15,
    sorter = {},
    filters = "",
  ) => ({
    type: Types.GET_STOCK_ITEM_INDEX,
    payload: { groupId, farmId, page, size, sorter, filters },
  }),
  indexStockItemSuccess: (data, pagination) => ({
    type: Types.GET_STOCK_ITEM_INDEX_SUCCESS,
    payload: { data, pagination },
  }),
  indexStockItemError: (error) => ({
    type: Types.GET_STOCK_ITEM_INDEX_ERROR,
    payload: { error },
  }),

  showStockItem: (groupId, farmId, id) => ({
    type: Types.GET_STOCK_ITEM_SHOW,
    payload: { groupId, farmId, id },
  }),
  showStockItemSuccess: (data) => ({
    type: Types.GET_STOCK_ITEM_SHOW_SUCCESS,
    payload: { data },
  }),
  showStockItemError: (error) => ({
    type: Types.GET_STOCK_ITEM_SHOW_ERROR,
    payload: { error },
  }),

  saveStockItem: (groupId, farmId, id = null, item) => ({
    type: Types.SAVE_STOCK_ITEM,
    payload: { groupId, farmId, id, item },
  }),
  saveStockItemSuccess: () => ({
    type: Types.SAVE_STOCK_ITEM_SUCCESS,
    payload: {},
  }),
  saveStockItemError: (error) => ({
    type: Types.SAVE_STOCK_ITEM_ERROR,
    payload: { error },
  }),

  deleteStockItem: (groupId, farmId, id) => ({
    type: Types.DELETE_STOCK_ITEM,
    payload: { groupId, farmId, id },
  }),
  deleteStockItemSuccess: () => ({
    type: Types.DELETE_STOCK_ITEM_SUCCESS,
    payload: {},
  }),
  deleteStockItemError: (error) => ({
    type: Types.DELETE_STOCK_ITEM_ERROR,
    payload: { error },
  }),

  toggleStatusStockItem: (groupId, farmId, id, active) => ({
    type: Types.TOGGLE_STATUS_STOCK_ITEM,
    payload: { groupId, farmId, id, active },
  }),
  toggleStatusStockItemSuccess: () => ({
    type: Types.TOGGLE_STATUS_STOCK_ITEM_SUCCESS,
    payload: {},
  }),
  toggleStatusStockItemError: (error) => ({
    type: Types.TOGGLE_STATUS_STOCK_ITEM_ERROR,
    payload: { error },
  }),

  showDrawerStockItem: () => ({
    type: Types.SHOW_DRAWER_STOCK_ITEM,
    payload: {},
  }),
  hideDrawerStockItem: () => ({
    type: Types.HIDE_DRAWER_STOCK_ITEM,
    payload: {},
  }),

  showModalNewStockItem: () => ({
    type: Types.SHOW_MODAL_NEW_STOCK_ITEM,
    payload: {},
  }),
  hideModalNewStockItem: () => ({
    type: Types.HIDE_MODAL_NEW_STOCK_ITEM,
    payload: {},
  }),

  resetDataStockItem: () => ({
    type: Types.RESET_DATA_STOCK_ITEM,
    payload: {},
  }),

  getDropdownStockItem: (groupId, farmId) => ({
    type: Types.GET_STOCK_ITEM_DROPDOWN,
    payload: { groupId, farmId },
  }),
  getDropdownStockItemSuccess: (data) => ({
    type: Types.GET_STOCK_ITEM_DROPDOWN_SUCCESS,
    payload: { data },
  }),
  getDropdownStockItemError: (error) => ({
    type: Types.GET_STOCK_ITEM_DROPDOWN_ERROR,
    payload: { error },
  }),

  refreshListDropDownStockItem: (newStockItem = null) => ({
    type: Types.REFRESH_LIST_DROPDOWN_STOCK_ITEM,
    payload: { newStockItem },
  }),
};

const INITIAL_STATE = {
  isLoading: false,
  isLoadingEdit: false,
  data: [],
  dataItem: null,
  pagination: { total: 0, size: 15, page: 0, sorter: {}, filters: "" },
  isDrawerVisible: false,
  isModalVisible: false,
  error: null,
  listDropDown: [],
  isLoadingDropDown: false,
  newStockItem: null,
  shouldRefreshListDropDown: false,
};

export default function stockItem(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.RESET_DATA_STOCK_ITEM:
      return INITIAL_STATE;
    case Types.CHANGE_STOCK_PAGINATION:
      return {
        ...state,
        pagination: {
          ...state.pagination,
          page: action.payload.page,
          size: action.payload.size,
        },
      };
    case Types.GET_STOCK_ITEM_INDEX:
      return { ...state, isLoading: true };
    case Types.GET_STOCK_ITEM_INDEX_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: action.payload.data,
        pagination: action.payload.pagination,
      };
    case Types.GET_STOCK_ITEM_INDEX_ERROR:
      return { ...state, isLoading: false, error: action.payload.error };

    case Types.GET_STOCK_ITEM_SHOW:
      return { ...state, isLoadingEdit: true };
    case Types.GET_STOCK_ITEM_SHOW_SUCCESS:
      return { ...state, isLoadingEdit: false, dataItem: action.payload.data };
    case Types.GET_STOCK_ITEM_SHOW_ERROR:
      return { ...state, isLoadingEdit: false, error: action.payload.error };

    case Types.SAVE_STOCK_ITEM:
      return { ...state, isLoadingEdit: true };
    case Types.SAVE_STOCK_ITEM_SUCCESS:
      return {
        ...state,
        isLoadingEdit: false,
        isModalVisible: false,
        isDrawerVisible: false,
        dataItem: null,
      };
    case Types.SAVE_STOCK_ITEM_ERROR:
      return { ...state, isLoadingEdit: false, error: action.payload.error };

    case Types.DELETE_STOCK_ITEM:
      return { ...state, isLoading: true };
    case Types.DELETE_STOCK_ITEM_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isDrawerVisible: false,
        dataItem: null,
      };
    case Types.DELETE_STOCK_ITEM_ERROR:
      return { ...state, isLoading: false, error: action.payload.error };

    case Types.TOGGLE_STATUS_STOCK_ITEM:
      return { ...state, isLoadingEdit: true };
    case Types.TOGGLE_STATUS_STOCK_ITEM_SUCCESS:
      return { ...state, isLoadingEdit: false };
    case Types.TOGGLE_STATUS_STOCK_ITEM_ERROR:
      return { ...state, isLoadingEdit: false, error: action.payload.error };

    case Types.SHOW_DRAWER_STOCK_ITEM:
      return { ...state, isDrawerVisible: true };
    case Types.HIDE_DRAWER_STOCK_ITEM:
      return { ...state, isDrawerVisible: false, dataItem: null };

    case Types.SHOW_MODAL_NEW_STOCK_ITEM:
      return { ...state, isModalVisible: true };
    case Types.HIDE_MODAL_NEW_STOCK_ITEM:
      return { ...state, isModalVisible: false };

    case Types.GET_STOCK_ITEM_DROPDOWN:
      return { ...state, isLoadingDropDown: true };
    case Types.GET_STOCK_ITEM_DROPDOWN_SUCCESS:
      return {
        ...state,
        isLoadingDropDown: false,
        listDropDown: action.payload.data,
      };
    case Types.GET_STOCK_ITEM_DROPDOWN_ERROR:
      return {
        ...state,
        isLoadingDropDown: false,
        error: action.payload.error,
      };

    case Types.REFRESH_LIST_DROPDOWN_STOCK_ITEM:
      return {
        ...state,
        newStockItem: action.payload.newStockItem,
        shouldRefreshListDropDown: !state.shouldRefreshListDropDown,
      };

    default:
      return state;
  }
}
